import { Outlet } from "react-router-dom";

export default function Financing() {
  return <Outlet />;
}
